module.exports = __webpack_public_path__ + "static/media/personlig_traning_2_kvalite.daec93e0.jpg";